module.exports = __webpack_public_path__ + "static/img/re-sign-data.5091474.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/re-sign-data.png
// module id = Eh7y
// module chunks = 1